export default "__VITE_ASSET__BbQqGeB0__"